import { omit } from "lodash";
const OVERWRITE_ACTIONS = [
    "GET_ALL_COMPANY_EMAIL_SETTING_SUCCESS",
    "GET_ALL_REGION_SUCCESS",
    "GET_ALL_BUSINESS_UNIT_SUCCESS",
];

export function autoReduce(action: any, state: any) {
    if (action?.normalized) {
        Object.keys(action.normalized.entities).forEach((key) => {
            const newEntities = action.normalized.entities[key];
            const shouldOverwrite = OVERWRITE_ACTIONS.includes(action.type);

            if (shouldOverwrite) {
                // Overwrite in all cases
                state[key] = newEntities && Object.keys(newEntities).length > 0
                    ? newEntities
                    : {};
            } else {
                // Merge only if new entities exist
                if (newEntities && Object.keys(newEntities).length > 0) {
                    state[key] = {
                        ...state[key],
                        ...newEntities,
                    };
                }
            }
        });
    }
    if (action.removeKeys) {
        for (let i = 0; i < action.removeKeys.length; i += 1) {
            state[action.removeKeys[i].entities] = omit(
                state[action.removeKeys[i].entities],
                action.removeKeys[i].ids
            );
        }
    }
    if (action.setKeys) {
        for (let i = 0; i < action.setKeys.length; i += 1) {
            state[action.setKeys[i].stateKey][action.setKeys[i].key] = action.setKeys[i].value
        }
    }
    if (action.overrides) {
        action.overrides.map((x: any) => {
            if (x.value) {
                state[x.key] = x.value;
            }
            return null;
        });
    }

    return { ...state };
}